<template>
  <div class="maintenance-overlay" v-if="enabled">
    <div class="maintenance-content">
      <div class="maintenance-inner">
        <img
          v-if="logo"
          :src="logo"
          alt="maintenance-logo"
          class="maintenance-logo"
        />
        <p class="maintenance-text" v-if="text">{{ text }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'MaintenanceOverlay',
  props: {
    enabled: { type: Boolean, default: false },
    logo: { type: String, default: '' },
    text: { type: String, default: '' }
  },
  methods: {
    applyScrollLock(on) {
      try {
        const html = document.documentElement;
        const body = document.body;
        if (on) {
          html.style.overflow = 'hidden';
          body.style.overflow = 'hidden';
        } else {
          html.style.overflow = '';
          body.style.overflow = '';
        }
      } catch (err) {
        // Ignore scroll lock errors (e.g., during SSR or restricted environments)
        return;
      }
    }
  },
  watch: {
    enabled(newVal) {
      this.applyScrollLock(!!newVal);
    }
  },
  mounted() {
    this.applyScrollLock(this.enabled);
  },
  beforeUnmount() {
    this.applyScrollLock(false);
  }
});
</script>

<style scoped>
.maintenance-overlay {
  position: fixed;
  inset: 0;
  background: #fff; /* White background */
  z-index: 9000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  text-align: center;
}
.maintenance-content {
  max-width: min(92vw, 720px);
  color: #000; /* Black text */
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.maintenance-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.maintenance-logo {
  width: clamp(180px, 30vw, 350px);
  height: auto;
  margin-bottom: 24px;
  display: block;
  object-fit: contain;
}
.maintenance-text {
  font-size: clamp(18px, 4vw, 24px);
  line-height: 1.6;
  font-weight: 600;
  color: #1F2548;
  white-space: pre-wrap;
  margin-top: 10px;
}
</style>
